import api from "./api/api";

const REPORT_SUBSCRIPTION_SHARING_API = '/api/report-subscription-sharing';

// Share a report subscription
export const shareReportSubscription = async (reportSubscriptionId, recipientIds, shareMessage = '', isUniversal = false, activeFacilities = null) => {
    try {
        const response = await api.post(`${REPORT_SUBSCRIPTION_SHARING_API}/share`, {
            reportSubscriptionId,
            recipientIds,
            shareMessage,
            isUniversal,
            activeFacilities
        });
        return response;
    } catch (error) {
        console.error('Error sharing report subscription:', error);
        throw error;
    }
};

// Respond to share invitation
export const respondToReportSubscriptionShare = async (shareId, response, newName = null) => {
    try {
        const result = await api.post(`${REPORT_SUBSCRIPTION_SHARING_API}/respond`, {
            shareId,
            response,
            newName
        });
        return result;
    } catch (error) {
        console.error('Error responding to report subscription share:', error);
        throw error;
    }
};

// Get shared report subscriptions
export const getSharedReportSubscriptions = async (page = null, includeOwned = false, additionalParams = {}) => {
    try {
        const params = { includeOwned, ...additionalParams };
        if (page) {
            params.page = page;
        }
        
        const response = await api.get(`${REPORT_SUBSCRIPTION_SHARING_API}/shared`, {
            params
        });
        return response;
    } catch (error) {
        console.error('Error getting shared report subscriptions:', error);
        throw error;
    }
};

// Get existing shares for a specific report subscription
export const getReportSubscriptionShares = async (reportSubscriptionId) => {
    try {
        const response = await api.get(`${REPORT_SUBSCRIPTION_SHARING_API}/${reportSubscriptionId}/shares`);
        return response;
    } catch (error) {
        console.error('Error getting report subscription shares:', error);
        throw error;
    }
}; 